import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseRegisterComponent } from './register.component';

const routes = [
    {
        path     : 'pages/auth/register',
        component: FuseRegisterComponent
    }
];

@NgModule({
    declarations: [
        FuseRegisterComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class RegisterModule
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/authentication/register/register.module.ts